/**
 * useTransactionDialog Hook
 *
 * Consumer hook for the transaction dialog context.
 * Provides a clean API for showing transaction progress dialogs.
 */

import { useTransactionDialogContext, TransactionMetadata, TransactionType } from '@/contexts/TransactionDialogContext';

export function useTransactionDialog() {
  const context = useTransactionDialogContext();

  return {
    // State
    isOpen: context.isOpen,
    state: context.state,
    metadata: context.metadata,
    countdownSeconds: context.countdownSeconds,

    // Actions
    startTransaction: context.startTransaction,
    setConfirmed: context.setConfirmed,
    setFailed: context.setFailed,
    dismiss: context.dismiss,
    retry: context.retry,
  };
}

// Re-export types for convenience
export type { TransactionMetadata, TransactionType };
